import { createGlobalState } from 'utils/create-global-state';
import { Props as CustomHeaderProps } from 'components/commons/header/CustomHeader';
// FIXME: AdviceContentsHeaderはimportから除外したい

export enum types {
  default,
  adviceContents,
  customContents,
}

type useHeaderProps =
  | {
      type: types.default;
    }
  | ({
      type: types.customContents;
    } & CustomHeaderProps);

type setCustomHeader = CustomHeaderProps;

const globalValue = createGlobalState<useHeaderProps>({
  type: types.default,
});

export function useHeader(): [
  useHeaderProps,
  {
    setDefaultHeader: () => void;
    /**
     * @deprecated setCustomHeaderを利用するようにする
     */
    setCustomHeader: (value: setCustomHeader) => void;
  }
] {
  const [state, setState] = globalValue();

  function setDefaultHeader() {
    setState({
      type: types.default,
    });
  }

  function setCustomHeader(value: CustomHeaderProps) {
    setState({
      type: types.customContents,
      children: value.children,
    });
  }

  return [state, { setDefaultHeader, setCustomHeader }];
}
